enum constants {
  APPLICATION_INSTALL_SET_STEP = 'APPLICATION_INSTALL_SET_STEP',
}

export default constants
